import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
export const pageSearch = {
  'invoInfoid': {
    title: '制票通知单号',
    type: 'input',
    equation: all
  },
  'wInvoInfoid': {
    title: '外部制票通知单号',
    type: 'input',
    equation: all
  },
  zzfld000001: {
    title: '营销战区',
    type: 'select',
    dictionary: 'sale'
  },
  'orderCust': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户编号'
    }
  },
  'orderCustName': {
    title: '订单客户名称',
    type: 'input'
  },
  'customer': {
    title: '开票客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '开票客户编号'
    },
    unSearchRole: 'WLY001'
  },
  'custName': {
    title: '开票客户名称',
    type: 'input',
    unSearchRole: 'WLY001'
  },
  'makDate': {
    title: '开票日期',
    type: 'date',
    equation: all,
    valueFormat: 'yyyy-MM-dd'
  },
  'productCode': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品编码'
    }
  },
  'productDesc': {
    title: '产品名称',
    type: 'input'
  },
  'invoId': {
    title: '发票号',
    type: 'input',
    equation: all
  },
  'manualInvo': {
    title: '手工发票号',
    type: 'input',
    equation: all
  },
  'isClear': {
    title: '是否已结清',
    type: 'select',
    dictionary: 'B0099',
    equation: all
  }
}

export default {
  'invoInfoid': {
    title: '制票通知单号',
    slot: true
  },
  'wInvoInfoid': {
    title: '外部制票通知单号',
    width: 150
  },
  'makDate': {
    title: '开票日期'
  },
  'infTypeTextView': {
    title: '制票单类型',
    width: 180
  },
  'zzfld000001': {
    describe: true, // 描述 _text 添加属性
    suffix: 'TextView',
    title: '营销战区', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale', // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
    width: 160
  },
  'invoId': {
    title: '发票号'
  },
  'manualInvo': {
    title: '手工发票号'
  },
  'customer': {
    title: '开票客户编号'
  },
  'custName': {
    title: '开票客户名称',
    width: 200
  },
  'orderCust': {
    title: '订单客户编号'
  },
  'orderCustName': {
    title: '订单客户名称',
    width: 200
  },
  'productCode': {
    title: '产品编码'
  },
  'productDesc': {
    title: '产品名称',
    width: 300
  },
  'invoiceQty': {
    title: '开票数量',
    width: 90,
    xlsxFmt: {
      t: 'n'
    }
  },
  'transferQty': {
    title: '转移数量',
    width: 90,
    xlsxFmt: {
      t: 'n'
    }
  },
  'deliveryQty': {
    title: '已发货量',
    width: 90,
    xlsxFmt: {
      t: 'n'
    }
  },
  'auditQty': {
    title: '审批中数量',
    width: 100,
    xlsxFmt: {
      t: 'n'
    }
  },
  'availableQty': {
    title: '可用量',
    width: 90,
    xlsxFmt: {
      t: 'n'
    }
  },
  'invTypeTextView': {
    title: '发票类型'
  },
  'invAmount': {
    title: '发票总金额',
    width: 110,
    slot: true,
    xlsxFmt: {
      t: 'n'
    }
  },
  /*'planTypeplanType': {
    title: '计划类型',
    width: 200
  },*/
  'planType': {
    describe: true,
    suffix: 'TextView',
    title: '计划类型',
    type: 'select',
    equation: all,
    dictionary: 'A0002',
    width: 160
  },
  //'invStatusTextView': {
  //  title: '单据状态'
  //},
  'isClearTextView': {
    title: '是否结清',
    width: 100
  }
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/data-searching/config/invoiceSearch.js